import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import api from "@/lib/api";
import MarkdownView from "@/components/MarkdownView";
import { Sparkles } from "lucide-react";

export default function SharedReport() {
  const { shareId } = useParams();
  const [report, setReport] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    api.get(`/public/reports/${shareId}`)
      .then((res) => setReport(res.data))
      .catch((err) => setError(err?.response?.data?.detail || "This report is unavailable."));
  }, [shareId]);

  return (
    <div className="min-h-screen bg-background">
      <header className="border-b border-slate-200 bg-white">
        <div className="max-w-3xl mx-auto px-6 py-4 flex items-center gap-2">
          <div className="h-7 w-7 rounded-md bg-[#ECECEC] flex items-center justify-center"><Sparkles className="h-4 w-4 text-[#202123]" /></div>
          <img src="/jotbay-logo.png" alt="JotBay" className="h-6 w-auto" />
        </div>
      </header>
      <div className="max-w-3xl mx-auto px-6 py-10">
        {error && <div className="rounded-xl border border-slate-200 bg-white p-10 text-center text-slatebody" data-testid="shared-error">{error}</div>}
        {!error && !report && <p className="text-slatebody">Loading…</p>}
        {report && (
          <div className="rounded-xl border border-slate-200 bg-white p-8 md:p-12 animate-fade-up" data-testid="shared-report">
            <p className="font-mono text-[11px] uppercase text-slatebody mb-6">
              {report.range_type} report{report.author_name ? ` · ${report.author_name}` : ""}{report.start_date ? ` · ${report.start_date} → ${report.end_date}` : ""}
            </p>
            <MarkdownView content={report.content} />
          </div>
        )}
      </div>
    </div>
  );
}
